<template>
  <span class="hint"><slot /></span>
</template>

<style lang="scss" scoped>
.hint {
  width: 100%;
  font-size: 12px;
  color: var(--text-secondary);
}
</style>
